/*******************************************************************************
TRIGGER GET MORE TEAM NEWS
Trigger appending more team news updates to the page.
*******************************************************************************/

import getArticles from './get-articles';
import removeButtonProcessingState from '../../universal/button-state/remove-button-processing-state';
import activateCloudinaryImages from '../../universal/cloudinary/activate';

export default async function triggerGetArticles(e) {
    const $showMoreButton = $(e.currentTarget);

    // Options on Show More button
    const sport = String($showMoreButton.data('sport') || '').toLowerCase();
    const content = $showMoreButton.data('content') || '';
    const column = $showMoreButton.data('column') || '';
    const author = $showMoreButton.data('author') || '';
    const noColumnInHeadline = $showMoreButton.data('no-column-in-headline') || '';
    const lastArticleDate = $showMoreButton.data('last-article-date') || '';
    const numArticles = $showMoreButton.data('num-articles') || '';

    // Add the options that were set on the button
    const settings = {};
    if (sport) { settings.sport = sport; }
    if (content) { settings.content = content; }
    if (column) { settings.column = column; }
    if (author) { settings.author = author; }
    if (noColumnInHeadline) { settings.noColumnInHeadline = noColumnInHeadline; }
    if (lastArticleDate) { settings.lastArticleDate = lastArticleDate; }
    if (numArticles) { settings.numArticles = numArticles; }

    try {
        // Find the articles that match the last article date on the page
        // We're going to send a list of these IDs to getArticles() so we don't get back duplicates
        // We have to do this because articles don't have real timestamps (just dates) and IDs don't necessarily correspond to publish time :-(
        settings.exclude = [];
        $(`.content-preview[data-article-date="${lastArticleDate}"]`).each((i, a) => {
            settings.exclude.push($(a).data('articleid'));
        });

        // Get the set of articles
        // If any of the values below are undefined, the rest of this try block won't run
        const { articlesHTML, newLastArticleDate, noMoreArticles } = await getArticles(settings);

        // Update the button's "lastarticledate" data attribute
        $showMoreButton.data('last-article-date', newLastArticleDate);

        // Add the articles to the page
        $showMoreButton.prevAll('.article-list').append(articlesHTML);

        // load the images
        activateCloudinaryImages();

        // Check if a hidden content type filter (DFS/Traditional) should be made visible
        const sportInName = sport ? `-${sport.toUpperCase()}` : '';
        const $hiddenContentFilter = $(`.toggle-tabs-set[data-name="article-type-${sportInName}"].hide`);
        if ($hiddenContentFilter.length) {
            const numDFS = $('.article-preview.is-dfs').length;
            const numTraditional = $('.article-preview.is-traditional').length;
            if (numDFS > 0 && numTraditional > 0) { $hiddenContentFilter.removeClass('hide'); }
        }

        // If there were no articles returned, hide the show more button (since there is no more)
        if (noMoreArticles) { $showMoreButton.remove(); }
    }
    catch (err) {
        // Error message already triggered in get-articles.js
    }

    // Reset the button to its original state
    removeButtonProcessingState($showMoreButton);
}
